import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Login() {
  const { login, register, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("login");
  const [error, setError] = useState("");

  const [loginId, setLoginId] = useState("");
  const [loginPass, setLoginPass] = useState("");

  const [regUser, setRegUser] = useState("");
  const [regPhone, setRegPhone] = useState("");
  const [regPass, setRegPass] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(loginId, loginPass);
      navigate("/");
    } catch (err) {
      setError(err.message || "Invalid username or password");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    if (!regUser || !regPhone || !regPass) {
      setError("All fields are required");
      return;
    }
    if (regPhone.length < 10) {
      setError("Phone number must be at least 10 digits");
      return;
    }
    if (regPass.length < 4) {
      setError("Password must be at least 4 characters");
      return;
    }
    try {
      await register(regUser, regPhone, regPass);
      navigate("/");
    } catch (err) {
      setError(err.message || "Registration failed");
    }
  };

  const handleGoogle = async () => {
    setError("");
    try {
      await googleLogin();
      navigate("/");
    } catch (err) {
      setError(err.message || "Google sign-in failed");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-tabs">
          <button
            className={`auth-tab ${tab === "login" ? "active" : ""}`}
            onClick={() => { setTab("login"); setError(""); }}
          >
            Login
          </button>
          <button
            className={`auth-tab ${tab === "register" ? "active" : ""}`}
            onClick={() => { setTab("register"); setError(""); }}
          >
            Register
          </button>
        </div>

        {error && <p className="auth-error">{error}</p>}

        <button type="button" className="google-auth-btn" onClick={handleGoogle}>
          <svg viewBox="0 0 48 48" width="20" height="20">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </button>

        <div className="auth-divider"><span>or</span></div>

        {tab === "login" ? (
          <form onSubmit={handleLogin} className="auth-form">
            <label>
              Username or Phone
              <input
                type="text"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                required
                placeholder="Enter username or phone"
              />
            </label>
            <label>
              Password
              <input
                type="password"
                value={loginPass}
                onChange={(e) => setLoginPass(e.target.value)}
                required
                placeholder="Enter password"
              />
            </label>
            <button type="submit" className="auth-submit">Login</button>
            <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="auth-form">
            <label>
              Username
              <input
                type="text"
                value={regUser}
                onChange={(e) => setRegUser(e.target.value)}
                required
                placeholder="Choose a username"
              />
            </label>
            <label>
              Phone Number
              <input
                type="tel"
                value={regPhone}
                onChange={(e) => setRegPhone(e.target.value)}
                required
                placeholder="e.g. 0712345678"
              />
            </label>
            <label>
              Password
              <input
                type="password"
                value={regPass}
                onChange={(e) => setRegPass(e.target.value)}
                required
                placeholder="At least 4 characters"
              />
            </label>
            <button type="submit" className="auth-submit">Create Account</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Login;
